// Lib
import React from 'react';
import { CSSTransitionGroup } from '../../../node_module_clones/react-transition-group';

// Context
import { useToastRendererContext } from './ToastContext';

// Styles
import './ToastRenderer.scss';

const ToastRenderer: React.FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = (
    props,
) => {
    const toasts = useToastRendererContext();

    return (
        <div {...props} className="ToastRenderer">
            <CSSTransitionGroup
                transitionName="fade-and-slide"
                transitionAppear
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}
                transitionAppearTimeout={300}
            >
                {[...toasts].map(([toastId, toast], index) =>
                    // Add the index as a custom property so we can perform CSS positioning and transitions using it
                    React.cloneElement(toast, { key: toastId, style: { '--index': index } }),
                )}
            </CSSTransitionGroup>
        </div>
    );
};

export default React.memo(ToastRenderer);
